import { Stack } from '@festina-life/ui/structure'

import { useRequiredWorkspaceOperationsContext } from '../../workspace/operationsContext'
import { ShadowedTemplateLinks } from '../shadowedTemplateLinks/ShadowedTemplateLinks'

export const WorkspaceShadowedOperationsPanel = () => {
  const { workspaceShadowedTemplateOperations, workspaceKey } =
    useRequiredWorkspaceOperationsContext()

  return (
    <Stack gap="condensed" padding="condensed" className="flex-col">
      <ShadowedTemplateLinks
        conflicts={workspaceShadowedTemplateOperations}
        branch={workspaceKey.branchKey}
        workspaceName={workspaceKey.name}
      />
    </Stack>
  )
}
